export function orderTypeMatches(a: string | undefined | null, b: string | undefined | null): boolean {
    if (!a || !b) {
        return false;
    }
    return a.trim().toLowerCase() === b.trim().toLowerCase();
}

export function orderTypesInclude(types: string[] | undefined | null, activeType: string | undefined | null): boolean {
    if (!types || !types.length || !activeType) {
        return false;
    }
    return types.some((t) => orderTypeMatches(t, activeType));
}
